(() => {
  let preferredMode = null;
  let preferredPlanValue = "";
  let preferredPlanText = "";
  let restoring = false;
  let updateTimer;

  const cleanPrice = (price) => {
    if (!price) return "";

    return price
      .replace(/\s+(GBP|USD|EUR)$/i, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const activeBlock = () =>
    document.querySelector(
      ".shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)"
    );

  const isOneTimeInput = (input) => {
    if (!input) return false;

    const type = (
      input.dataset.radioType || ""
    ).toLowerCase();

    const optionCard = input.closest(
      ".shopify_subscriptions_app_block_label"
    );

    return (
      type.includes("one_time") ||
      input.classList.contains(
        "shopify_subscriptions_app_block_one_time_purchase_option"
      ) ||
      optionCard?.classList.contains(
        "shopify_subscriptions_purchase_option_wrapper"
      )
    );
  };

  const rememberInput = (input) => {
    if (!input) return;

    if (isOneTimeInput(input)) {
      preferredMode = "one_time";
      return;
    }

    preferredMode = "subscription";

    preferredPlanValue =
      input.dataset.sellingPlanId ||
      input.value ||
      preferredPlanValue;

    preferredPlanText =
      input.closest("label")?.textContent
        ?.replace(/\s+/g, " ")
        .trim() || preferredPlanText;
  };

  const rememberSelect = (select) => {
    if (!select) return;

    preferredMode = "subscription";
    preferredPlanValue = select.value;

    preferredPlanText =
      select.selectedOptions?.[0]?.textContent
        ?.replace(/\s+/g, " ")
        .trim() || "";
  };

  const getSelectedPurchase = () => {
    const block = activeBlock();
    if (!block) return null;

    const selected = block.querySelector(
      'input[type="radio"]:checked'
    );

    if (!selected) return null;

    const subscription = !isOneTimeInput(selected);

    const optionCard = selected.closest(
      ".shopify_subscriptions_app_block_label"
    );

    let price = selected.dataset.variantPrice;

    if (!price && subscription) {
      price =
        optionCard?.querySelector(
          ".allocation_price:not(.shopify_subscriptions_app_block--hidden)"
        )?.textContent ||
        block.querySelector(
          ".allocation_price:not(.shopify_subscriptions_app_block--hidden)"
        )?.textContent;
    }

    if (!price && !subscription) {
      const oneTime = block.querySelector(
        '[data-radio-type="one_time_purchase"], .shopify_subscriptions_app_block_one_time_purchase_option'
      );

      price =
        oneTime?.dataset.variantPrice ||
        optionCard?.querySelector(
          ".shopify_subscriptions_in_widget_price"
        )?.textContent;
    }

    return {
      subscription,
      price: cleanPrice(price)
    };
  };

  const getAddButton = () => {
    const root = document.querySelector("main") || document;

    const buttons = [
      ...root.querySelectorAll(
        [
          'product-form button[name="add"]',
          'form[action*="/cart/add"] button[name="add"]',
          'form[action*="/cart/add"] button[type="submit"]',
          ".product-form__submit",
          ".btn--atc"
        ].join(",")
      )
    ];

    return buttons.find(
      (button) =>
        button.offsetParent !== null &&
        !button.closest("product-card") &&
        !button.closest(".quick-add") &&
        !button.closest(".quick-buy")
    );
  };

  const getButtonText = (button) => {
    const selectors = [
      ".js-product-form-submit-text",
      ".add-to-cart-text",
      ".btn__text",
      ".button__text",
      ".atc-button-text",
      ".quick-add-btn-text"
    ];

    for (const selector of selectors) {
      const element = button.querySelector(selector);
      if (element) return element;
    }

    const matchingSpan = [
      ...button.querySelectorAll("span")
    ].find((span) => {
      const text = span.textContent.trim();

      return (
        text &&
        !span.classList.contains("visually-hidden") &&
        !span.querySelector("svg") &&
        /add to cart|subscribe|preorder/i.test(text)
      );
    });

    if (matchingSpan) return matchingSpan;

    return [...button.childNodes].find(
      (node) =>
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim()
    );
  };

  const setButtonText = (button, label) => {
    if (!button || !label) return;

    button.setAttribute(
      "data-add-to-cart-text",
      label
    );

    const target = getButtonText(button);

    if (target?.nodeType === Node.TEXT_NODE) {
      if (target.textContent.trim() !== label) {
        target.textContent = ` ${label} `;
      }

      return;
    }

    if (target) {
      if (target.textContent.trim() !== label) {
        target.textContent = label;
      }

      return;
    }

    let customLabel =
      button.querySelector(".warf-atc-label");

    if (!customLabel) {
      customLabel = document.createElement("span");
      customLabel.className = "warf-atc-label";
      button.appendChild(customLabel);
    }

    customLabel.textContent = label;
  };

  const updateButton = () => {
    const button = getAddButton();
    const purchase = getSelectedPurchase();

    if (!button || !purchase) return;

    if (
      button.disabled ||
      button.getAttribute("aria-disabled") === "true"
    ) {
      return;
    }

    const action = purchase.subscription
  ? "Subscribe"
  : "Add to cart";

    const label = purchase.price
      ? `${action} · ${purchase.price}`
      : action;

    setButtonText(button, label);
  };

  const scheduleUpdate = (delay = 60) => {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(updateButton, delay);
  };

  const restorePurchaseChoice = () => {
    if (!preferredMode || restoring) return;

    const block = activeBlock();
    if (!block) return;

    const radios = [
      ...block.querySelectorAll(
        'input[type="radio"]'
      )
    ];

    if (!radios.length) return;

    restoring = true;

    const oneTimeRadio = radios.find(
      isOneTimeInput
    );

    const subscriptionRadios = radios.filter(
      (radio) => !isOneTimeInput(radio)
    );

    if (preferredMode === "one_time") {
      if (oneTimeRadio && !oneTimeRadio.checked) {
        oneTimeRadio.click();
      }
    } else {
      let subscriptionRadio =
        subscriptionRadios.find((radio) => {
          const value =
            radio.dataset.sellingPlanId ||
            radio.value;

          return (
            preferredPlanValue &&
            value === preferredPlanValue
          );
        });

      if (!subscriptionRadio && preferredPlanText) {
        const savedText =
          preferredPlanText.toLowerCase();

        subscriptionRadio =
          subscriptionRadios.find((radio) => {
            const labelText =
              radio.closest("label")?.textContent
                ?.replace(/\s+/g, " ")
                .trim()
                .toLowerCase() || "";

            return (
              labelText.includes(savedText) ||
              savedText.includes(labelText)
            );
          });
      }

      subscriptionRadio =
        subscriptionRadio ||
        subscriptionRadios[0];

      if (
        subscriptionRadio &&
        !subscriptionRadio.checked
      ) {
        subscriptionRadio.click();
      }

      const select = block.querySelector("select");

      if (select) {
        const options = [...select.options];

        let savedOption = options.find(
          (option) =>
            preferredPlanValue &&
            option.value === preferredPlanValue
        );

        if (!savedOption && preferredPlanText) {
          const savedText =
            preferredPlanText.toLowerCase();

          savedOption = options.find((option) => {
            const optionText =
              option.textContent
                .replace(/\s+/g, " ")
                .trim()
                .toLowerCase();

            return optionText === savedText;
          });
        }

        if (
          savedOption &&
          select.value !== savedOption.value
        ) {
          select.value = savedOption.value;

          select.dispatchEvent(
            new Event("input", {
              bubbles: true
            })
          );

          select.dispatchEvent(
            new Event("change", {
              bubbles: true
            })
          );
        }
      }
    }

    setTimeout(() => {
      restoring = false;
      updateButton();
    }, 60);
  };

  const restoreAfterVariantChange = () => {
    [60, 180, 350, 650].forEach((delay) => {
      setTimeout(() => {
        restorePurchaseChoice();
        updateButton();
      }, delay);
    });
  };

  const isVariantControl = (target) => {
    if (
      target.closest(
        ".shopify_subscriptions_app_block"
      )
    ) {
      return false;
    }

    return Boolean(
      target.matches(
        [
          'input[name^="options"]',
          'select[name^="options"]',
          'input[name="id"]',
          'select[name="id"]'
        ].join(",")
      ) ||
        target.closest(
          [
            "variant-picker",
            "variant-selects",
            ".variant-picker",
            ".variant-input",
            ".option-selector",
            ".product-options"
          ].join(",")
        )
    );
  };

  document.addEventListener(
    "change",
    (event) => {
      const target = event.target;

      if (
        target.closest(
          ".shopify_subscriptions_app_block"
        )
      ) {
        if (event.isTrusted && !restoring) {
          if (
            target.matches(
              'input[type="radio"]'
            )
          ) {
            rememberInput(target);
          }

          if (target.matches("select")) {
            rememberSelect(target);
          }
        }

        scheduleUpdate(50);
        return;
      }

      if (isVariantControl(target)) {
        restoreAfterVariantChange();
      }
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      if (isVariantControl(event.target)) {
        restoreAfterVariantChange();
      }
    },
    true
  );

  const start = () => {
    setTimeout(() => {
      if (!preferredMode) {
        const block = activeBlock();

        const selected = block?.querySelector(
          'input[type="radio"]:checked'
        );

        if (selected) {
          rememberInput(selected);

          if (preferredMode === "subscription") {
            const select =
              block.querySelector("select");

            if (select) rememberSelect(select);
          }
        }
      }

      updateButton();
    }, 500);

    const observerRoot =
      document.querySelector("main") ||
      document.body;

    const observer = new MutationObserver(() => {
      scheduleUpdate(80);
    });

    observer.observe(observerRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        "class",
        "checked",
        "disabled",
        "data-variant-id"
      ]
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start
    );
  } else {
    start();
  }
})();

/* ========================================
   WARF PREMIUM PACK SIZE CARDS
======================================== */

(() => {
  const normalize = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || "GBP";
    const locale = document.documentElement.lang || "en-GB";

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  };

  const getPackInformation = (text) => {
    const originalText = String(text || "").trim();

    const packMatch =
      originalText.match(/pack\s+of\s+(\d+)/i) ||
      originalText.match(/(\d+)\s*pack/i);

    const weightMatch = originalText.match(
      /(\d+(?:[.,]\d+)?)\s*(kg|g|gr|oz|lb)/i
    );

    const packCount = packMatch ? Number(packMatch[1]) : null;

    return {
      count: packCount,
      name: packCount ? `${packCount} Pack` : originalText,
      weight: weightMatch
        ? `${weightMatch[1]} ${weightMatch[2]} each`
        : ""
    };
  };

  const getVariantOptions = (variant) => {
    if (Array.isArray(variant.options)) {
      return variant.options;
    }

    return [
      variant.option1,
      variant.option2,
      variant.option3
    ].filter(Boolean);
  };

  const findVariant = (product, input) => {
    const inputValue = normalize(input.value);

    return product.variants.find((variant) => {
      return getVariantOptions(variant).some(
        (option) => normalize(option) === inputValue
      );
    });
  };

  const getLabel = (input) => {
    if (!input.id) return input.nextElementSibling;

    return document.querySelector(
      `label[for="${CSS.escape(input.id)}"]`
    );
  };

  const createElement = (className, text) => {
    const element = document.createElement("span");
    element.className = className;
    element.textContent = text;
    return element;
  };

  const renderPackFieldset = (fieldset, product) => {
    const inputs = Array.from(
      fieldset.querySelectorAll('input[type="radio"]')
    );

    if (inputs.length < 2) return;

    const cards = inputs
      .map((input) => {
        const label = getLabel(input);
        if (!label) return null;

        if (!label.dataset.warfOriginalText) {
          label.dataset.warfOriginalText =
            label.textContent.trim();
        }

        const information = getPackInformation(
          label.dataset.warfOriginalText
        );

        const variant = findVariant(product, input);
        const price = Number(variant?.price || 0);

        const unitPrice =
          information.count && price
            ? price / information.count
            : null;

        return {
          input,
          label,
          information,
          variant,
          price,
          unitPrice
        };
      })
      .filter(Boolean);

    if (!cards.length) return;

    const validUnitPrices = cards
      .map((card) => card.unitPrice)
      .filter((price) => Number.isFinite(price));

    const lowestUnitPrice = validUnitPrices.length
      ? Math.min(...validUnitPrices)
      : null;

    cards.forEach((card) => {
      const {
        input,
        label,
        information,
        variant,
        price,
        unitPrice
      } = card;

      label.classList.add("warf-pack-option");
      label.classList.toggle("is-selected", input.checked);
      label.classList.toggle(
        "is-unavailable",
        variant?.available === false
      );

      const isBestValue =
        lowestUnitPrice !== null &&
        cards.length > 1 &&
        unitPrice === lowestUnitPrice;

      label.classList.toggle("is-best-value", isBestValue);
      label.replaceChildren();

      if (isBestValue) {
        label.appendChild(
          createElement(
            "warf-pack-card__badge",
            "Best value"
          )
        );
      }

      label.appendChild(
        createElement(
          "warf-pack-card__name",
          information.name
        )
      );

      if (information.weight) {
        label.appendChild(
          createElement(
            "warf-pack-card__weight",
            information.weight
          )
        );
      }

      if (price) {
        label.appendChild(
          createElement(
            "warf-pack-card__price",
            formatMoney(price)
          )
        );
      }

      if (unitPrice) {
        label.appendChild(
          createElement(
            "warf-pack-card__unit",
            `${formatMoney(unitPrice)} / pack`
          )
        );
      }
    });

    const labelsParent =
      cards[0].label.parentElement;

    if (labelsParent) {
      labelsParent.classList.add("warf-pack-options");
    }
  };

  const findPackFieldsets = () => {
    return Array.from(document.querySelectorAll("fieldset"))
      .filter((fieldset) => {
        const legend = fieldset.querySelector("legend");
        const title = normalize(legend?.textContent);

        return title === "pack size" || title === "size";
      });
  };

  let cachedProduct = null;

  const getProduct = async () => {
    if (cachedProduct) return cachedProduct;

    const productPath =
      window.location.pathname.replace(/\/$/, "") + ".js";

    const response = await fetch(productPath);

    if (!response.ok) {
      throw new Error("Product data could not be loaded.");
    }

    cachedProduct = await response.json();
    return cachedProduct;
  };

  const initializePackCards = async () => {
    const fieldsets = findPackFieldsets();

    if (!fieldsets.length) return;

    try {
      const product = await getProduct();

      fieldsets.forEach((fieldset) => {
        renderPackFieldset(fieldset, product);
      });
    } catch (error) {
      console.warn("[Warf Pack Cards]", error);
    }
  };

  document.addEventListener("change", (event) => {
    if (
      event.target.matches(
        'input[type="radio"], select'
      )
    ) {
      window.setTimeout(initializePackCards, 30);
      window.setTimeout(initializePackCards, 250);
    }
  });

  const observer = new MutationObserver(() => {
    window.clearTimeout(window.warfPackCardTimer);

    window.warfPackCardTimer = window.setTimeout(
      initializePackCards,
      100
    );
  });

  const start = () => {
    initializePackCards();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();